import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './redux/store';
import ReactGA from 'react-ga';

import { ToastContainer, toast } from 'react-toastify';
import config from 'config';
import App from './App';
history.listen(() => {
  // Enable tracking with GA
  // if (config.ga.enabled) {
  //   let page = window.location.pathname + window.location.search,
  //     options = {};
  //   ReactGA.set({
  //     page,
  //     location: `${window.location.origin}${page}`,
  //     ...options,
  //   });
  //   ReactGA.pageview(page);
  // }

  window.scrollTo(0, 0);
});

ReactDOM.render(
  <Provider store={store}>
      <ConnectedRouter history={history}>
          <App />
      </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
